import * as Yup from 'yup'
import {
  CVVreg,
  ExpiryCardreg,
  gstNumberreg,
  IFSCCodereg,
  MIDreg,
  MobileNumberreg,
  OTPreg,
  Passwordreg,
  Pincodereg,
} from './regex'

export const Name = Yup.string().min(2, 'Too Short!').max(60, 'Too Long!').required('Required')

export const Mid = Yup.string()
  .required('Required')
  .min(15, 'MID  must be 15 digits')
  .matches(MIDreg, 'Only 15 digit mid allowed')

export const AccountHolderName = Yup.string().min(2, 'Too Short!').max(40, 'Too Long!').required('Required')

export const AccountNumber = Yup.string().min(2, 'Too Short!').max(60, 'Too Long!').required('Required')

export const IFSCCode = Yup.string()
  .min(4, 'Enter valid IFSC Code')
  .max(11, 'Enter valid IFSC Code')
  .required('Required')
  .matches(IFSCCodereg, 'Enter valid IFSC Code')

export const Pincode = Yup.string()
  .length(6, 'Pincode is 6 digits')
  .min(6, 'Pincode is 6 digits')
  .required('Required')
  .test(
    'Test if its a valid',
    `Invalid Pincode.
Provide a valid area pincode.`,
    (value: string) => {
      return Pincodereg.test(value)
    },
  )
export const FileName = Yup.string().min(2, 'Invalid File!').required('Required')

export const mobileNumber = Yup.string()
  .required('Enter mobile number')
  .min(10, 'Mobile number must be 10 digits')
  .matches(MobileNumberreg, 'Enter valid mobile number')

export const otp = Yup.string()
  .required('Enter OTP')
  .min(6, 'OTP must be 6 digits')
  .matches(OTPreg, 'Only 6 digit otp allowed')

export const setPassword = Yup.string()
  .min(8, 'Min 8 characters required')
  .required('Required')
  .matches(
    Passwordreg,
    'Password Invalid, Password Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character.',
  )
export const password = Yup.string().min(8, 'Min 8 characters required').required('Required')

export const passwordMatch = Yup.object().shape({
  password,
  passwordConfirm: Yup.string().when('password', {
    is: (val) => !!(val && val.length > 0),
    then: Yup.string().oneOf([Yup.ref('password')], 'Both password does not match'),
  }),
})

export const cvv = Yup.string().required('Required').matches(CVVreg, 'Only 3 digit number allowed')

export const expiry = Yup.string()
  .min(4, 'Enter valid 4 digits')
  .required('Required')
  .matches(ExpiryCardreg, 'Invalid Date (mm/yy). Starting digit must be 0 or 1 eg: 09/19')

export const email = Yup.string().email('Invalid email').required('Required')

export const webAddress = Yup.string().url('Invalid url').required('Required')

export const addressLine = Yup.string().required('Required!').min(6, 'Too short address value!')

export const gstNumber = Yup.string()
  .required('Required!')
  .max(15, 'GST Id number should be 15 characters long')
  .matches(gstNumberreg, 'Invalid GST Id number')

export const dropDown = Yup.string().required('Please select an option from the list!')

export const Regex = Yup.string().test(
  'Test if its a valid',
  `Invalid Pincode.
Provide a valid area pincode.`,
  (value: string) => {
    return /^[1-9][0-9]{5}$/.test(value)
  },
)

export const accNumber = Yup.string()
  .required('Required')
  .matches(/^\d{9,18}$/, 'Incorrect Account Number')

export const confAccNumber = Yup.string()
  .oneOf([Yup.ref('bankacNo'), null], 'account number must match ')
  .required('Required')

export const fileTransferSchemaValidation = Yup.object()
  .required('Required')
  .test('Test the schema', 'Enter value for all the fileds.', (value: any): boolean => {
    let isValid = false
    if (value && value !== null && typeof value === 'object') {
      const data = JSON.parse(JSON.stringify(value))
      if (
        data.hasOwnProperty('emailRecipients') &&
        data.emailRecipients?.length >= 1
        //&& data.hasOwnProperty('emailConfigPassKey')
      ) {
        isValid = true
      }
      //console.log('isValid', isValid, data.emailRecipients, data.emailConfigPassKey)
      return isValid
    } else {
      return isValid
    }
  })

export const sftpFileTransferSchemaValidation = Yup.object()
  .required('Required')
  .test('Test the schema', 'Enter value for all the fileds.', (value: any): boolean => {
    let isValid = false
    if (value && value !== null && typeof value === 'object') {
      const data = JSON.parse(JSON.stringify(value))

      if (
        data.hasOwnProperty('sftpNotifyRecipients') &&
        data.sftpNotifyRecipients?.length >= 1
        //&& data.hasOwnProperty('sftpConfigPassKey')
      ) {
        isValid = true
      }
      return isValid
    } else {
      return isValid
    }
  })

export const emailAndSftpFileTransferSchemaValidation = Yup.object()
  .required('Required')
  .test('Test email and SFTP schema', 'Enter value for all the fileds.', (value: any): boolean => {
    let isValid = false
    if (value && value !== null && typeof value === 'object') {
      const data = JSON.parse(JSON.stringify(value))
      if (
        data.hasOwnProperty('sftpNotifyRecipients') &&
        data.sftpNotifyRecipients?.length >= 1 &&
        //data.sftpConfigPassKey?.length >= 1 &&
        //data.hasOwnProperty('sftpConfigPassKey') &&
        //alphaNumericValidation?.test(data.sftpConfigPassKey) &&
        data.hasOwnProperty('emailRecipients') &&
        data.emailRecipients?.length >= 1
        //&& data.hasOwnProperty('emailConfigPassKey')
        // && alphaNumericValidation?.test(data.emailConfigPassKey)
      ) {
        isValid = true
      }
      return isValid
    } else {
      return isValid
    }
  })
